import type { CustomTemplateData } from "@jugl-web/rest-api";
import type { CXAutomationFormState } from "../types";
import { appendQueryParams, rowsToBody, rowsToObject } from "./requestShape";
import { toSnakeCase } from "./variableName";

export const serializeAutomationToCustomTemplate = (
  state: CXAutomationFormState,
  previousEnabled = true
): CustomTemplateData => {
  const name = toSnakeCase(state.automationName);
  const description = state.description.trim();
  const headers = rowsToObject(state.requestRowsByTab.headers);

  const url = appendQueryParams(
    state.urlMarkdown,
    state.requestRowsByTab.parameters
  );
  const body: Record<string, unknown> =
    state.method === "GET" ? {} : rowsToBody(state.requestRowsByTab.body);

  const variables = state.dataInputs
    .map((input) => ({
      name: toSnakeCase(input.name),
      desc: input.description.trim(),
    }))
    .filter((variable) => variable.name);

  return {
    enabled: previousEnabled,
    name,
    description,
    method: state.method,
    url,
    headers,
    body,
    variables,
  };
};

export const isAutomationFormValid = (
  state: CXAutomationFormState
): boolean => {
  if (!state.automationName.trim()) return false;
  if (!state.description.trim()) return false;
  const url = state.urlMarkdown.trim();
  if (!url || !/^https:\/\//i.test(url)) return false;
  const namedInputs = state.dataInputs.filter(
    (input) => input.name.trim() || input.description.trim()
  );
  if (namedInputs.some((input) => !input.name.trim())) return false;
  return true;
};
